import { render, staticRenderFns } from "./Verifyyouremail.vue?vue&type=template&id=5a943a3a&scoped=true&"
import script from "./Verifyyouremail.vue?vue&type=script&lang=js&"
export * from "./Verifyyouremail.vue?vue&type=script&lang=js&"
import style0 from "./Verifyyouremail.vue?vue&type=style&index=0&id=5a943a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a943a3a",
  null
  
)

export default component.exports